/* Shop the Look Multiple: abre un panel lateral con los productos del look
   y los agrega al carrito sin cerrar el panel. */
(function () {
  'use strict';

  function ShopTheLook(section) {
    this.section = section;
    this.id = section.getAttribute('data-stlm-section');
    this.drawer = section.querySelector('[data-stlm-drawer]') ||
      document.querySelector('[data-stlm-drawer="' + this.id + '"]');
    if (!this.drawer) return;

    // El panel se mueve al <body> para que ningún contenedor con transform/overflow lo recorte
    if (this.drawer.parentNode !== document.body) {
      var stale = document.body.querySelectorAll(':scope > [data-stlm-drawer="' + this.id + '"]');
      stale.forEach(function (el) { if (el !== this.drawer) el.remove(); }, this);
      document.body.appendChild(this.drawer);
    }

    this.body = this.drawer.querySelector('[data-stlm-body]');
    this.txt = {
      add: this.drawer.getAttribute('data-txt-add'),
      adding: this.drawer.getAttribute('data-txt-adding'),
      added: this.drawer.getAttribute('data-txt-added'),
      soldout: this.drawer.getAttribute('data-txt-soldout'),
      error: this.drawer.getAttribute('data-txt-error')
    };

    this.titleEl = this.drawer.querySelector('.stlm-drawer__title');
    this.defaultTitle = this.titleEl ? this.titleEl.textContent : '';

    this.initArrows();

    this.onKeydown = this.onKeydown.bind(this);
    section.addEventListener('click', this.onSectionClick.bind(this));
    this.drawer.addEventListener('click', this.onDrawerClick.bind(this));
    this.drawer.addEventListener('change', this.onDrawerChange.bind(this));
  }

  // Flechas del carrusel: avanzan de a un look y dan la vuelta en los extremos
  ShopTheLook.prototype.initArrows = function () {
    var track = this.section.querySelector('[data-stlm-track]');
    var prev = this.section.querySelector('[data-stlm-prev]');
    var next = this.section.querySelector('[data-stlm-next]');
    if (!track || !prev || !next) return;

    function step() {
      var item = track.querySelector('.stlm-item');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function max() { return track.scrollWidth - track.clientWidth; }

    prev.addEventListener('click', function () {
      if (track.scrollLeft <= 2) track.scrollTo({ left: max(), behavior: 'smooth' });
      else track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      if (track.scrollLeft >= max() - 2) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: step(), behavior: 'smooth' });
    });
  };

  ShopTheLook.prototype.onSectionClick = function (e) {
    var trigger = e.target.closest('[data-stlm-open]');
    if (!trigger) return;
    e.preventDefault();
    this.open(trigger.getAttribute('data-stlm-open'), trigger);
  };

  ShopTheLook.prototype.open = function (blockId, trigger) {
    var tpl = this.section.querySelector('template[data-stlm-look="' + blockId + '"]');
    if (!tpl) return;
    this.body.innerHTML = '';
    this.body.appendChild(tpl.content.cloneNode(true));
    if (this.titleEl) this.titleEl.textContent = tpl.getAttribute('data-title') || this.defaultTitle;
    this.lastTrigger = trigger || null;

    var drawer = this.drawer;
    drawer.hidden = false;
    document.documentElement.classList.add('stlm-lock');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    });
    document.addEventListener('keydown', this.onKeydown);
    var closeBtn = drawer.querySelector('.stlm-drawer__close');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
  };

  ShopTheLook.prototype.close = function () {
    var drawer = this.drawer;
    if (drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.removeEventListener('keydown', this.onKeydown);
    setTimeout(function () {
      drawer.hidden = true;
      if (!document.querySelector('.stlm-drawer.is-open')) {
        document.documentElement.classList.remove('stlm-lock');
      }
    }, 350);
    if (this.lastTrigger) this.lastTrigger.focus({ preventScroll: true });
  };

  ShopTheLook.prototype.onKeydown = function (e) {
    if (e.key === 'Escape') { this.close(); return; }
    if (e.key !== 'Tab') return;
    // Mantiene el foco dentro del panel
    var focusables = Array.prototype.filter.call(
      this.drawer.querySelectorAll('a[href], button:not([disabled]), select:not([disabled])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  ShopTheLook.prototype.onDrawerClick = function (e) {
    if (e.target.closest('[data-stlm-close]')) { this.close(); return; }
    var addBtn = e.target.closest('[data-stlm-add]');
    if (addBtn) this.add(addBtn);
  };

  ShopTheLook.prototype.onDrawerChange = function (e) {
    var select = e.target.closest('select[data-stlm-variant]');
    if (!select) return;
    var row = select.closest('[data-stlm-product]');
    var opt = select.options[select.selectedIndex];
    row.querySelector('[data-stlm-price]').textContent = opt.getAttribute('data-price');
    var compare = row.querySelector('[data-stlm-compare]');
    var compareVal = opt.getAttribute('data-compare');
    compare.textContent = compareVal || '';
    compare.hidden = !compareVal;
    this.resetButton(row.querySelector('[data-stlm-add]'), !opt.disabled);
    this.showError(row, '');
  };

  ShopTheLook.prototype.resetButton = function (btn, available) {
    clearTimeout(btn._stlmTimer);
    btn.classList.remove('is-added', 'is-loading');
    btn.disabled = !available;
    btn.textContent = available ? this.txt.add : this.txt.soldout;
  };

  ShopTheLook.prototype.showError = function (row, msg) {
    var el = row.querySelector('[data-stlm-error]');
    el.textContent = msg;
    el.hidden = !msg;
  };

  ShopTheLook.prototype.add = function (btn) {
    if (btn.disabled || btn.classList.contains('is-loading')) return;
    var self = this;
    var row = btn.closest('[data-stlm-product]');
    var variantId = row.querySelector('[data-stlm-variant]').value;

    var cartDrawer = document.querySelector('cart-drawer');
    var canRenderDrawer = !!(cartDrawer && typeof cartDrawer.getSectionsToRender === 'function');
    var sections = canRenderDrawer
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-icon-bubble'];

    clearTimeout(btn._stlmTimer);
    btn.classList.remove('is-added');
    btn.classList.add('is-loading');
    btn.textContent = this.txt.adding;
    this.showError(row, '');

    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) throw new Error(data.description || data.message || '');
          return data;
        });
      })
      .then(function (data) {
        self.refreshCart(data, canRenderDrawer ? cartDrawer : null);
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = self.txt.added;
        btn._stlmTimer = setTimeout(function () { self.resetButton(btn, true); }, 3000);
      })
      .catch(function (err) {
        self.resetButton(btn, true);
        self.showError(row, (err && err.message) || self.txt.error);
      });
  };

  // Actualiza el carrito lateral y el contador del tema SIN abrir el carrito
  ShopTheLook.prototype.refreshCart = function (data, cartDrawer) {
    var sectionsHtml = data.sections || {};
    try {
      if (cartDrawer) {
        cartDrawer.getSectionsToRender().forEach(function (s) {
          if (!sectionsHtml[s.id]) return;
          var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
          if (el) el.innerHTML = cartDrawer.getSectionInnerHTML(sectionsHtml[s.id], s.selector);
        });
        cartDrawer.classList.remove('is-empty');
        var inner = cartDrawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof cartDrawer.close === 'function') {
          overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
        }
      } else if (sectionsHtml['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        var parsed = new DOMParser().parseFromString(sectionsHtml['cart-icon-bubble'], 'text/html')
          .querySelector('.shopify-section');
        if (bubble && parsed) bubble.innerHTML = parsed.innerHTML;
      }
      if (typeof window.freeShippMsg === 'function') window.freeShippMsg();
    } catch (e) {
      console.error('[Shop the Look Multiple]', e);
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  };

  var instances = {};

  function init(root) {
    (root || document).querySelectorAll('[data-stlm-section]').forEach(function (section) {
      if (section._stlm) return;
      section._stlm = new ShopTheLook(section);
      instances[section.getAttribute('data-stlm-section')] = section._stlm;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Soporte para el editor de temas
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (!id || !instances[id]) return;
    instances[id].close();
    var d = instances[id].drawer;
    setTimeout(function () { if (d && d.parentNode) d.remove(); }, 400);
    delete instances[id];
  });
  // Al seleccionar un bloque "Look" en el editor, abre su panel para previsualizar
  document.addEventListener('shopify:block:select', function (e) {
    var id = e.detail && e.detail.sectionId;
    var inst = instances[id];
    if (!inst) return;
    var trigger = inst.section.querySelector('[data-stlm-open="' + e.detail.blockId + '"]');
    if (trigger) inst.open(e.detail.blockId, trigger);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var inst = instances[e.detail && e.detail.sectionId];
    if (inst) inst.close();
  });
})();
